import { debounce } from "lodash";
import moment from "moment";
import Hashids from "hashids";
import { useTranslation } from "react-i18next";

export const getToken = () => localStorage.getItem("TOKEN");
export const getTokenMember = () => localStorage.getItem("TOKEN_MEMBER");
export const setTokenMember = (key: string, token: string) =>
  localStorage.setItem(key, token);
export const logout = (not_redirect?: boolean) => {
  // ตรวจว่าเป็น session ของ member ก่อนล้าง เพื่อ redirect ให้ถูกหน้า
  const is_member = !!getTokenMember() && !getToken();
  localStorage.clear();
  localStorage.removeItem("TOKEN");
  localStorage.removeItem("CURRENT_PATH");
  if (!not_redirect) {
    window.location.href = is_member ? "/login-member" : "/login";
  }
};
export const getNavbarCurrentPath = () => localStorage.getItem("CURRENT_PATH");

export const handleTypingNumber = (even: any) => {
  if (!/[0-9.]/.test(even.key)) {
    even.preventDefault();
  }
};

export const formatNumber = (n: any) => {
  if (n == null) return ""; // ป้องกัน null/undefined
  const numStr = String(n);
  if (!/^\d+$/.test(numStr.replace(/\D/g, ""))) return n; // ถ้าไม่ใช่ตัวเลขล้วน return ค่าดิบ
  return numStr.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatCurrencyData = (
  value: string,
  mode: "input" | "convert" | "revert",
  blur?: any
): string | number | any => {
  if (!value.trim()) return "";
  switch (mode) {
    case "input":
      if (value === "" || value.charAt(0) === "0") {
        return "";
      }
      let inputVal = value;
      if (inputVal.indexOf(".") >= 0) {
        const decimalPos = inputVal.indexOf(".");
        const leftSide = inputVal.substring(0, decimalPos);
        const rightSide = inputVal.substring(decimalPos);

        inputVal = formatNumber(leftSide);

        if (blur === "blur") {
          inputVal += "00";
        }

        inputVal = `${inputVal}.${formatNumber(rightSide).substring(0, 2)}`;
      } else {
        inputVal = formatNumber(inputVal);

        if (blur === "blur") {
          inputVal += ".00";
        }
      }
      return inputVal;

    case "convert":
      const numberRevert = value.replaceAll(",", "");
      return Number(numberRevert);

    case "revert":
      const numericValue = parseFloat(value.replace(/,/g, ""));
      return numericValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    default:
      return value;
  }
};

export const formatPhoneNumberTh = (phoneNumber: string) => {
  if (!phoneNumber) return phoneNumber;
  const phoneNum = phoneNumber.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNum.length;
  if (phoneNumberLength < 4) return phoneNum;
  if (phoneNumberLength < 7) {
    return `${phoneNum.slice(0, 3)} ${phoneNum.slice(3)}`;
  }
  return `${phoneNum.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNum.slice(
    6,
    10
  )}`;
};

interface searchProps {
  searchItem: string;
  setItem: (value: string) => void;
}
export const debouncedApiCall = debounce((props: searchProps) => {
  props.setItem(props.searchItem);
}, 400);

export const formatDate = (date: Date | string, format: string) => {
  return moment(date).add(543, "years").format(format);
};

export const hasTrueValueKey = (obj: Record<string, any>): boolean => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] === true) {
      return true;
    }
  }
  return false;
};

export const validateEmail = (email: string): any => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export function createOnKeyPress(mode: "thai" | "english") {
  return function (event: React.KeyboardEvent<HTMLInputElement>) {
    const char = event.key;

    if (mode === "thai") {
      const isThai = /^[\u0E00-\u0E7F]+$/.test(char);
      const isControlKey = char.length > 1; // เช่น Shift, ArrowKey, Backspace
      if (!isThai && !isControlKey) {
        event.preventDefault();
      }
    } else if (mode === "english") {
      const isEnglish = /^[A-Za-z]+$/.test(char);
      const isControlKey = char.length > 1;
      if (!isEnglish && !isControlKey) {
        event.preventDefault();
      }
    }
  };
}

// หาปี
export function getSurroundingYears(year: number, range: number = 5): number[] {
  const currentYear = moment(`${year}`, "YYYY");
  const years: number[] = [];

  for (let i = -range; i <= range; i++) {
    years.push(currentYear.clone().add(i, "years").year());
  }

  return years;
}

// แปลงเลข
export const formatBudget = (value?: number): string => {
  if (value === undefined || value === null || isNaN(value)) return "-";

  const absValue = Math.abs(value);
  const isNegative = value < 0;
  let formatted = "";

  if (absValue >= 1_000_000) {
    formatted = (absValue / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  } else if (absValue >= 1_000) {
    formatted = (absValue / 1_000).toFixed(0) + "K";
  } else {
    formatted = absValue.toString();
  }

  return isNegative ? `-${formatted}` : formatted;
};

export const getBaseApi = (): string => process.env.REACT_APP_FILE_BASE_API!;

export enum MEDIA_ENUM {
  LOCAL_FILE = 1, // สำหรับ local file
}

export type permission_config = {
  isUpdate: boolean;
  isDelete: boolean;
  isView: boolean;
  // isApproved: boolean;
  isCreated: boolean;
  // isUpdateStatus: boolean;
  // isChangeMc: boolean;
};
export const checkPermission = (
  code: string,
  permission_config: { permit: boolean; code: string }[]
): permission_config => {
  // const objectPermission: permission_config = {
  //   isApproved: true,
  //   isCreated: true,
  //   isDelete: true,
  //   isUpdate: true,
  //   isView: true,
  //   isUpdateStatus: true,
  //   isChangeMc: true
  // };
  // รอ PERMISSION ถึงเปิดใช้งานได้

  const objectPermission: permission_config = {
    // isApproved: false,
    isCreated: false,
    isDelete: false,
    isUpdate: false,
    isView: false,
    // isUpdateStatus: false,
    // isChangeMc: false,
  };
  permission_config.forEach((menu) => {
    if (menu.code === `${code}.View` && menu.permit) {
      objectPermission.isView = true;
    }
    if (menu.code === `${code}.Create` && menu.permit) {
      objectPermission.isCreated = true;
    }
    if (menu.code === `${code}.Update` && menu.permit) {
      objectPermission.isUpdate = true;
    }
    if (menu.code === `${code}.Deleted` && menu.permit) {
      objectPermission.isDelete = true;
    }
    // if (menu.code === `${code}.Reset` && menu.permit) {
    //   objectPermission.isUpdateStatus = true;
    // }
    // if (menu.code === `${code}.Approve` && menu.permit) {
    //   objectPermission.isApproved = true;
    // }
    // if (menu.code === `${code}.ChangeMc` && menu.permit) {
    //   objectPermission.isChangeMc = true;
    // }
  });

  return objectPermission;
};

export const renderDate = (date: string, time?: boolean) => {
  if (time) {
    return moment(date).add("year", 543).format("DD/MM/YYYY HH:mm");
  }
  return moment(date).add("year", 543).format("DD/MM/YYYY");
};

export const isVideoUrl = (url: string): boolean => {
  if (!url) return false;

  try {
    const videoExtensions = [
      ".mp4",
      ".webm",
      ".ogg",
      ".mov",
      ".mkv",
      ".avi",
      ".flv",
      ".wmv",
      ".3gp",
    ];

    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname.toLowerCase();
    const pathname = parsedUrl.pathname.toLowerCase();

    if (hostname.includes("youtube.com") || hostname.includes("youtu.be")) {
      return true;
    }

    return videoExtensions.some((ext) => pathname.endsWith(ext));
  } catch {
    return false;
  }
};

export const formatFileSize = (
  bytes: number,
  decimalPlaces: number = 1
): string => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  const size = parseFloat((bytes / Math.pow(k, i)).toFixed(decimalPlaces));
  return `${size} ${sizes[i]}`;
};

export function decodeId(hash: string): number | null {
  const salt = process.env.REACT_APP_SECRET_SALT!;
  if (!salt) throw new Error("Missing HASHID_SECRET_SALT");

  const hashids = new Hashids(salt, 50);
  const decoded = hashids.decode(hash);
  if (decoded.length === 0) return null;

  const value = decoded[0];
  return typeof value === "bigint" ? Number(value) : value;
}

export const shareToFacebook = (url: string) => {
  const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    url
  )}`;
  window.open(shareUrl, "_blank", "noopener,noreferrer,width=600,height=400");
};

export const shareToX = (url: string, text?: string) => {
  const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    url
  )}${text ? `&text=${encodeURIComponent(text)}` : ""}`;
  window.open(shareUrl, "_blank", "noopener,noreferrer,width=600,height=400");
};

export const shareToLine = (url: string, text?: string) => {
  const shareUrl = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
    url
  )}${text ? `%0A${encodeURIComponent(text)}` : ""}`;
  window.open(shareUrl, "_blank", "noopener,noreferrer,width=600,height=400");
};

//  รหัสผ่าน 8 ตัวขึ้นไป โดยประกอบด้วยตัวอักษร และตัวเลข
export function isValidPassword(password: string): boolean {
  // เช็คความยาว >= 8
  if (password.length < 8) return false;

  // เช็คว่ามีตัวอักษร (a-z, A-Z)
  const hasLetter = /[a-zA-Z]/.test(password);

  // เช็คว่ามีตัวเลข (0-9)
  const hasNumber = /[0-9]/.test(password);

  return hasLetter && hasNumber;
}

export function isValidMp3Link(url: string): boolean {
  try {
    const u = new URL(url);
    return u.pathname.toLowerCase().endsWith(".mp3");
  } catch {
    return false;
  }
}
export function isValidMp4Link(url: string): boolean {
  try {
    const u = new URL(url);
    return u.pathname.toLowerCase().endsWith(".mp4");
  } catch {
    return false; // ไม่ใช่ลิงก์ที่ถูกต้อง
  }
}

export function Translation(text: string) {
  const { t } = useTranslation();
  return t(text);
}
export function openGoogleMapByLatLng(lat: number, lng: number, zoom: number = 16) {
  const url = `https://www.google.com/maps/@${lat},${lng},${zoom}z`;
  window.open(url, "_blank");
}

export function validateObject<T extends Record<string, any>>(
  data: T,
  options?: {
    exclude?: (keyof T)[];
    customMessage?: Partial<Record<keyof T, string>>;
  }
): {
  is_valid: boolean;
  errors: Partial<Record<keyof T, string>>;
} {
  const errors: Partial<Record<keyof T, string>> = {};

  const exclude = options?.exclude ?? [];
  const customMessage = (options?.customMessage ??
    {}) as Partial<Record<keyof T, string>>;

  for (const key in data) {
    const typedKey = key as keyof T;

    if (exclude.includes(typedKey)) continue;

    const value = data[typedKey];
    const msg = customMessage[typedKey] ?? "ระบุข้อมูลช่องนี้";

    if (typeof value === "string" && value.trim() === "") {
      errors[typedKey] = msg;
      continue;
    }
    if (value === null || value === undefined) {
      errors[typedKey] = msg;
      continue;
    }
    if (Array.isArray(value) && value.length === 0) {
      errors[typedKey] = msg;
      continue;
    }
  }

  return {
    is_valid: Object.keys(errors).length === 0,
    errors,
  };
}

export const renderDateDefault = (date: string) => {
  return moment(date).format("DD/MM/YYYY")
}

// แปลงวันที่/เวลาเป็นรูปแบบไทย เช่น "1 มี.ค. 2568 15:00 น." (ปี พ.ศ. = ค.ศ. + 543)
export const renderDateTimeThai = (date: string) => {
  if (!date || !moment(date).isValid()) return "-";
  return moment(date).locale("th").add(543, "year").format("D MMM YYYY HH:mm") + " น.";
};


